export default "__VITE_ASSET__CYR5E3wl__"